export default __webpack_public_path__ + "bg-adaptivefca145.png";